import { useContext, useEffect, useState } from 'react';
import GuiContext from 'config/context/guiContext';

const GuiVersion = ({ color, size }) => {
    const { URL } = useContext(GuiContext);
    const [version, setVersion] = useState("2.4.2");

    useEffect(() => {
        let isMounted = true;

        const fetchVersion = async () => {
            try {
                const response = await fetch(`${URL}/api/inerygui/service_version`);
                const data = await response.json();

                if (isMounted && response.ok && data?.version) {
                    setVersion(data.version);
                }
            } catch (error) {
                // Keep fallback hardcoded version when fetch fails.
            }
        };

        fetchVersion();

        return () => {
            isMounted = false;
        };
    }, [URL]);

    return (
        <span
            style={{
                color: color ? color : "#FFFFFF",
                fontSize: size ? size : "12px"
            }}
        >
            v{version}
        </span>

    )
}

export default GuiVersion;